export default __webpack_public_path__ + "static/media/1X2.c0a9528c.svg";